import { useEffect, useState } from "react";

// False during SSR and the hydration render, true right after mount. Use it for
// values that change on every request (e.g. view counters) so the prerendered
// markup never disagrees with the client's first render.
export default function useHydrated() {
    const [hydrated, setHydrated] = useState(false);
    useEffect(() => setHydrated(true), []);
    return hydrated;
}
